/**
 * Done. CPD — Landing Hero Section (Stitch v2 / screen 1)
 */

interface HeroProps {
  onStart: () => void;
  onExplore: () => void;
}

export function Hero({ onStart, onExplore }: HeroProps): React.ReactElement {
  return (
    <section
      id="section-hero"
      className="relative min-h-[85vh] flex items-center overflow-hidden stitch-bg-mesh pt-24 pb-16 md:pt-32"
    >
      <div
        className="mx-auto px-4 md:px-10 w-full grid grid-cols-1 md:grid-cols-12 gap-6 items-center"
        style={{ maxWidth: 'var(--stitch-container-max)' }}
      >
        <div className="md:col-span-7 z-10">
          <h1 className="stitch-font-display text-[56px] md:text-[88px] text-[var(--stitch-primary)] leading-[0.95] mb-6 tracking-tighter uppercase">
            Done. CPD
          </h1>

          <div className="mb-10">
            <span className="inline-block px-4 py-2 bg-[var(--stitch-primary)] text-[var(--stitch-on-primary)] rounded-lg stitch-font-label text-[13px] tracking-[0.2em] uppercase mb-6">
              Structured. Supported. Completed.
            </span>
            <p className="stitch-font-headline text-[22px] md:text-[26px] text-[var(--stitch-on-surface-variant)] max-w-lg leading-snug uppercase">
              A new era in continuing professional development.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              type="button"
              onClick={onStart}
              className="px-8 md:px-10 py-4 md:py-5 bg-[var(--stitch-primary)] text-[var(--stitch-on-primary)] stitch-font-label text-[13px] rounded-xl hover:bg-[var(--stitch-primary-container)] transition-all stitch-ghost-shadow uppercase tracking-widest font-bold"
            >
              Get Started
            </button>
            <button
              type="button"
              onClick={onExplore}
              className="px-8 md:px-10 py-4 md:py-5 border-2 border-[var(--stitch-primary)] text-[var(--stitch-primary)] stitch-font-label text-[13px] rounded-xl hover:bg-[var(--stitch-primary)]/5 transition-all uppercase tracking-widest font-bold"
            >
              Explore Library
            </button>
          </div>
        </div>

        {/* Editorial visual + floating progress badge */}
        <div className="md:col-span-5 relative h-[360px] md:h-[560px] mt-12 md:mt-0">
          <div className="absolute inset-0 bg-[var(--stitch-primary)]/5 rounded-[48px] -rotate-2" aria-hidden="true" />
          <div
            className="absolute inset-0 rounded-[48px] shadow-2xl border border-white/20 bg-cover bg-center z-10"
            style={{
              backgroundImage:
                "linear-gradient(135deg, rgba(0,53,53,0.15), rgba(0,53,53,0.45)), url('https://lh3.googleusercontent.com/aida-public/AB6AXuAj0eFTVCrTu6lacj5zkePnVdBc1JVczZIPN2G8CYms3eGQzjnwHGdW4ajfkPughO5zjLVCgl08uyTqETi8T3DUwDlReRztdpJKinpslSazGFzcdSC176IfCf6Rz8bpuVIQO_8w718HfwmoYdu-qPixEbAt0BROwqHzCEbIfm8lZhXAKJndClp2FKqLkTF4ARvMkwKM1Aa0sh-7EG_uCRbHg0kKWZhpVdBk0mWjckD9SCiu_lVQtdXIki7iR9_YkKXD5_kqQHW5WCQ')",
            }}
            aria-hidden="true"
          />
          <div className="hidden md:block absolute -bottom-6 -left-6 z-20 bg-white/95 backdrop-blur-md p-6 rounded-3xl stitch-teal-border stitch-ghost-shadow w-64">
            <div className="flex items-center gap-4 mb-4">
              <div
                className="w-12 h-12 rounded-full stitch-circular-progress flex items-center justify-center"
                style={{ ['--progress' as string]: 92 } as React.CSSProperties}
              >
                <div className="w-9 h-9 rounded-full bg-white" />
              </div>
              <div>
                <p className="stitch-font-label text-[11px] text-[var(--stitch-primary)]/70 uppercase">Annual Goal</p>
                <p className="stitch-font-headline text-[18px] font-bold text-[var(--stitch-primary)]">18.5 / 20 hrs</p>
              </div>
            </div>
            <div className="w-full bg-[var(--stitch-surface-container)] h-2 rounded-full overflow-hidden">
              <div className="bg-[var(--stitch-primary)] h-full transition-all" style={{ width: '92%' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
